import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import LandingPage from "./pages/LandingPage";
import GetStartedPage from "./pages/GetStartedPage";
import SignupVerificationPage from "./pages/SignupVerificationPage";
import DashboardPage from "./pages/DashboardPage";
import ProgressPage from "./pages/ProgressPage";
import OnboardingQuestionnairePage from "./pages/OnboardingQuestionnairePage";
import OnboardingUploadPage from "./pages/OnboardingUploadPage";
import ExerciseDetailPage from "./pages/ExerciseDetailPage";
import RoadmapPage from "./pages/RoadmapPage";
import ProfilePage from "./pages/ProfilePage";
import SettingsPage from "./pages/SettingsPage";
import { AuthProvider } from "./context/auth";
import RequireAuth from "./components/auth/RequireAuth";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/questionnaire" element={<GetStartedPage />} />
            <Route path="/verify" element={<SignupVerificationPage />} />

            <Route
              path="/dashboard/onboarding/questionnaire"
              element={
                <RequireAuth>
                  <OnboardingQuestionnairePage />
                </RequireAuth>
              }
            />
            <Route
              path="/dashboard/onboarding/upload"
              element={
                <RequireAuth>
                  <OnboardingUploadPage />
                </RequireAuth>
              }
            />
            <Route
              path="/dashboard/upload"
              element={
                <RequireAuth>
                  <OnboardingUploadPage />
                </RequireAuth>
              }
            />

            <Route
              path="/dashboard"
              element={
                <RequireAuth>
                  <DashboardPage />
                </RequireAuth>
              }
            />
            <Route
              path="/dashboard/roadmap"
              element={
                <RequireAuth>
                  <RoadmapPage />
                </RequireAuth>
              }
            />
            <Route
              path="/dashboard/achievements"
              element={
                <RequireAuth>
                  <DashboardPage />
                </RequireAuth>
              }
            />
            <Route
              path="/exercise/:exerciseId"
              element={
                <RequireAuth>
                  <ExerciseDetailPage />
                </RequireAuth>
              }
            />
            <Route
              path="/progress"
              element={
                <RequireAuth>
                  <ProgressPage />
                </RequireAuth>
              }
            />
            <Route
              path="/settings"
              element={
                <RequireAuth>
                  <SettingsPage />
                </RequireAuth>
              }
            />
            <Route
              path="/profile"
              element={
                <RequireAuth>
                  <ProfilePage />
                </RequireAuth>
              }
            />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
